import { LoanProgram } from '@lendinghome/core/constants';

export const RESET_PASSWORD_TREATMENT_NAME = 'enable_auth0_reset_password';

export const PROGRAM_TO_START_NEW_LOAN_URL_PARAM_MAPPINGS = {
  [LoanProgram.HARD_MONEY]: 'bridge',
  [LoanProgram.HARD_MONEY_INFILL]: 'bridge',
  [LoanProgram.RENTAL]: 'rental',
};

export const REHAB_TYPES = {
  INFILL: 'INFILL',
};
